export default __webpack_public_path__ + "static/media/TheSimpsons.9c59f2e0.mp3";